<script lang="ts">
    import Vue from "vue";
    import { Component } from 'vue-facing-decorator';
    import { KendoChart } from "@Kendo/Components/KendoChart";
    import { BarChartDialogViewModel } from "@Evaluation/ValueAnalysis/Components/BarChartDialog";
    import { CriterionSelectorDialogViewModel } from "@Criteria/Hierarchies/Components/CriterionSelectorDialog";
    import CriterionSelectorDialog from "@Criteria/Hierarchies/Components/CriterionSelectorDialog.vue";

    @Component({
        components: {
            CriterionSelectorDialog
        },
        props: {
            viewModel: { type: Object, required: true }
        }
    })
    export default class BarChartDialog extends Vue
    {
        get vm(): BarChartDialogViewModel { return this.$props.viewModel as BarChartDialogViewModel; }        
        get opened(): boolean { return this.vm?.opened ?? false; }
        
        get theme(): string { return this.vm.theme; }
        set theme(val: string) { this.vm.theme = val; }
        
        get selectedCriterionName(): string | null { return this.vm.selectedCriterion?.Name ?? null; }
        get chart(): KendoChart { return this.vm.chart; }
        
        topLevel: boolean = true;
        criterionSelectorDialog: CriterionSelectorDialogViewModel = new CriterionSelectorDialogViewModel();
        themes: string[] = ["default", "black", "blueopal", "bootstrap", "highcontrast", "metro", "metroblack", "moonlight", "silver", "uniform"];

        showCriterionSelector()
        {
            this.criterionSelectorDialog.show(this.vm.criterionId, this.vm.criteria);
        }


        handleChangeCriterion(criterionId: number)
        {
            if (criterionId !== this.vm.criterionId)
            {
                this.vm.criterionId = criterionId;
                this.vm.setChartData(this.topLevel);
            }
        }

        handleChangeTheme(theme: string)
        {
            if (theme !== this.theme)
            {
                this.theme = theme;
                this.chart.SetTheme(theme);
            }
        }

        handleToggleLevel()
        {
            this.topLevel = !this.topLevel;
            this.vm.setChartData(this.topLevel);
        }

        close()
        {
            this.vm.close();
        }
    }
</script>

<template>
    <div>
        <div class="modal-mask" v-if="opened">
            <div class="modal-wrapper">
                <div class="modal-dialog modal-xl modal-dialog-scrollable">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">Bar chart</h5>
                            <button type="button" class="close" @click="close">&times;</button>
                        </div>

                        <div class="modal-body">
                            <div>
                                <button class="btn btn-outline-secondary" @click="showCriterionSelector">
                                    {{selectedCriterionName}}
                                </button>

                                <button class="btn btn-outline-secondary" @click="handleToggleLevel">
                                    <i class="fa-regular fa-fw" :class="topLevel ? 'fa-square' : 'fa-square-check'"></i>
                                    Bottom level
                                </button>

                                <div class="dropdown d-inline-block">
                                    <button class="btn btn-outline-secondary dropdown-toggle" data-toggle="dropdown">{{theme}}</button>
                                    <div class="dropdown-menu">
                                        <h6 class="dropdown-header">Color theme:</h6>
                                        <a class="dropdown-item" v-for="t in themes" :key="t" @click="handleChangeTheme(t)">{{t}}</a>
                                    </div>
                                </div>
                            </div>

                            <br />

                            <div style="max-height: calc(100vh-200px); overflow: auto;">
                                <div id="Chart-BarChart"></div>
                            </div>
                        </div>

                        <div class="modal-footer">
                            <button @click="close" type="button" class="btn btn-outline-secondary">Close</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <CriterionSelectorDialog :viewModel="criterionSelectorDialog"
                                 @confirm-selection="handleChangeCriterion" />
    </div>
</template>